import { render, staticRenderFns } from "./SearchCustomerForm.vue?vue&type=template&id=688fff55&scoped=true&"
import script from "./SearchCustomerForm.vue?vue&type=script&lang=js&"
export * from "./SearchCustomerForm.vue?vue&type=script&lang=js&"
import style0 from "./SearchCustomerForm.vue?vue&type=style&index=0&id=688fff55&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688fff55",
  null
  
)

export default component.exports